/** Save a rule draft (create or update), resolving tag names to tags first (tags.create returns an existing tag). */

import type { Engine, Rule, RuleId, Tag } from '@digester/core';
import { actionsOf, inputOf, type RuleDraft } from './model.js';

export async function saveRuleDraft(engine: Engine, rule: Rule | null, v: RuleDraft, tags: readonly Tag[]): Promise<RuleId> {
  const actions = await actionsOf(v.actions, tags, async (name) => (await engine.tags.create({ name, icon: 'tag' as never })).id);
  const input = inputOf(v, actions);
  if (rule) {
    const { kind: _kind, ...patch } = input;
    return (await engine.rules.update(rule.id, patch)).id;
  }
  return (await engine.rules.create(input)).id;
}
